import { createContext } from 'react';

import {
  VulnerabilityConnectionInput,
  VulnerabilityRelationshipReport,
  VulnerabilityRelationshipReportItem,
} from '@totem/components/vulnerabilities/overviewSummary/types';

interface Context {
  loading: boolean;
  data: VulnerabilityRelationshipReport;
  action: string;
  actionItem: VulnerabilityRelationshipReportItem;
  onAction: (
    action: string,
    actionItem: VulnerabilityRelationshipReportItem,
  ) => void;
  input: VulnerabilityConnectionInput;
  setInput: (input: VulnerabilityConnectionInput) => void;
}

export default createContext<Context>({
  loading: false,
  data: null,
  action: '',
  actionItem: null,
  onAction: () => {},
  input: null,
  setInput: () => {},
});
